/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LiveManagementListLivecarpRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: LiveManagementListLivecarpRequest.direction | null;
    status?: string | null;
    title?: string | null;
};

export namespace LiveManagementListLivecarpRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

